import axios from "@/libs/api.request";

// 获取文档列表
export const getDocumentList = params => {
  return axios.request({
    url: "/document/document",
    method: "get",
    params
  });
};

// 获取文档详情
export const getDocumentDetail = id => {
  return axios.request({
    url: "/document/document/" + id,
    method: "get"
  });
};

// 新增文档
export const addDocument = data => {
  return axios.request({
    url: "/document/document",
    method: "post",
    data
  });
};
// 编辑文档
export const editDocument = data => {
  return axios.request({
    url: "/document/document/" + data.id,
    method: "put",
    data
  });
};
// 删除文档
export const deleteDocument = id => {
  return axios.request({
    url: "/document/document/" + id,
    method: "delete"
  });
};
